import { CapacityContributionType } from '@navio/nsdk';
import { cn, NoddiIcon } from 'noddi-ui-common';
import { secondsToTimeString } from 'noddi-util';
import { CAPACITY_CONTRIBUTION_TYPE_ICON } from '../ServiceWorker/CapacityContributionTypeIcon';
import type { SlotCapacityInfo } from './slotCapacityInfo';

type Props = {
  capacity: SlotCapacityInfo;
  isSelected?: boolean;
  className?: string;
};

export const SlotCapacityInline = ({ capacity, isSelected, className }: Props) => {
  const remainingSeconds = capacity.totalRemainingSeconds;
  const remainingText =
    remainingSeconds != null
      ? secondsToTimeString({
          seconds: remainingSeconds,
          alwaysIncludeSeconds: false,
          shortFormat: true
        })
      : null;
  const showSupplyCounts = capacity.personalCount > 0 || capacity.baselineCount > 0;

  if (remainingText == null && !showSupplyCounts) {
    return null;
  }

  return (
    <span
      className={cn(
        'flex flex-col items-center justify-center text-xs leading-tight',
        !isSelected && 'text-muted-foreground',
        className
      )}
    >
      {remainingText != null && <span className='whitespace-nowrap'>{remainingText}</span>}
      {showSupplyCounts && (
        <span className='inline-flex items-center gap-1 whitespace-nowrap'>
          {capacity.personalCount > 0 && (
            <span className='inline-flex items-center gap-0.5'>
              <NoddiIcon name={CAPACITY_CONTRIBUTION_TYPE_ICON[CapacityContributionType.PERSONAL]} size='xSmall' />
              {capacity.personalCount}
            </span>
          )}
          {capacity.baselineCount > 0 && (
            <span className='inline-flex items-center gap-0.5'>
              <NoddiIcon name={CAPACITY_CONTRIBUTION_TYPE_ICON[CapacityContributionType.BASELINE]} size='xSmall' />
              {capacity.baselineCount}
            </span>
          )}
        </span>
      )}
    </span>
  );
};
